import React, { ReactElement, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import { getMembersQuantity } from 'api/requests';
import useWindowSize from 'utils/hooks/useWindowSize';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/company/vision-strategy/VisionAndStrategy.module.scss';

const SectionHeader = dynamic(() => import('sections/Company/VisionStrategy/components/SectionHeader/'));
const SectionPitch = dynamic(() => import('sections/Company/VisionStrategy/components/SectionPitch/'));
const SectionAbout = dynamic(() => import('sections/Company/VisionStrategy/components/SectionAbout/'));
const SectionDigitisation = dynamic(() => import('sections/Company/VisionStrategy/components/SectionDigitisation/'));
const SectionProducts = dynamic(() => import('sections/Company/VisionStrategy/components/SectionProducts/'));
const SectionGoal = dynamic(() => import('sections/Company/VisionStrategy/components/SectionGoal/'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionCallToAction = dynamic(() => import('sections/Company/VisionStrategy/components/SectionCallToAction/'));

const cn = classNames.bind(styles);

interface IProps {
  membersQuantity: number;
}

export default function VisionStrategy({ membersQuantity }: IProps) {
  const { width } = useWindowSize();
  const [isDataLayerSent, setIsDataLayerSent] = useState(false);

  useEffect(() => {
    if (width !== 0 && !isDataLayerSent) {
      // @ts-ignore
      window.dataLayer?.push({
        event: 'vision-strategy page',
        page_url: location.href,
      });
      setIsDataLayerSent(true);
    }
  }, [width, isDataLayerSent]);

  return (
    <div className={cn('vision-and-strategy')}>
      <SectionHeader membersQuantity={membersQuantity} />
      <SectionPitch />
      <SectionAbout />
      <SectionDigitisation />
      <SectionProducts />
      <SectionGoal />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionCallToAction /> */}
    </div>
  );
}

export const getStaticProps = async () => {
  const HOUR = 60 * 60;

  const meta = {
    title: 'Learn About Our Vision and Strategy | DF Alliance',
    description:
      'Learn about DF Alliance\'s vision and strategy for revolutionizing global logistics through innovative solutions and an interconnected network of professionals.',
    path: '/company/vision-strategy',
  };

  try {
    const data = await getMembersQuantity();
    return { props: { membersQuantity: data.data.accounts, ...meta }, revalidate: HOUR * 3 };
  } catch (e) {
    console.log('endpoints.membersQuantity', e);
  }

  return { props: { membersQuantity: 0, ...meta }, revalidate: HOUR * 3 };
};

VisionStrategy.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
